import service from '@/utils/request'
  
  export function get(url, params,header={}) {
    return service({
      url: url,
      method: 'get',
      params: params,
      headers:header
    })
  }
  export function post(url, params,header={}) {
    return service({
      url: url,
      method: 'post',
      data: params,
      headers:header
    })
  }